import { TABLA_CAMIONES_EN_PLAYA } from '../../../../../../config/tables'
import CpaEnPlaya from '../../../../../../models/camiones/cpa_en_playa'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import { COLUMNS_CAMIONES_EN_PLAYA_TO_PRINT, getColumnasCamionesEnPlaya } from './constantesCamionesEnPlaya'

export function actualizarDatosParaMuiTable (rol = null, filtroInicial = null) {
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_EN_PLAYA
    })
    CpaEnPlaya.getDataCamionesEnPlaya().then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, detalle: d, cartadeporte: d.numero }) })
      const textRowCount = 'Cantidad de camiones: '
      const columnas = getColumnasCamionesEnPlaya(rolAutorizado)

      const customToolbar = pdfCustomToolbarGenerator(
        'Camiones en Playa',
        data,
        COLUMNS_CAMIONES_EN_PLAYA_TO_PRINT,
        'landscape')

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Camiones en playa`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '599px',
            showRowCount: true,
            textRowCount,
            filtroInicial: filtroInicial
          }
        },
        id: TABLA_CAMIONES_EN_PLAYA
      })
    }
  }
}
